"use client"
import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function MakeOfferIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <title>{t`Make offer Icon`}</title>

      <ellipse
        cx="9.50471"
        cy="3.5"
        rx="2.49983"
        ry="2.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.00488 15.8571H2.28693C2.49823 15.8571 2.70895 15.8795 2.91556 15.9237L5.52371 16.4827C7.0859 16.8175 8.71561 16.6078 10.1422 15.8884L16.2277 12.8199C16.7036 12.5799 17.0038 12.0924 17.0038 11.5594V11.4333C17.0038 10.9906 16.7602 10.5838 16.37 10.3747V10.3747C16.0926 10.2261 15.768 10.1923 15.4659 10.2806L12.2041 11.2338M7.93774 12.4286L10.0709 11.8571L12.2041 11.2338M1.00488 10.1429L1.30383 10.0513C3.58057 9.35433 5.94837 9 8.32941 9H9.87619C10.6468 9 11.3489 9.44278 11.681 10.1382L12.2041 11.2338"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}
